import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
interface Order {
  client: string;
  date: string;
  order: string;
  items: string;
  total: string;
  status: string;
}
@Component({
  selector: 'app-fiber-create',
  standalone: true,
  imports: [     CommonModule,
    ReactiveFormsModule,
    DialogModule,
    InputTextModule,
    CalendarModule,
    DropdownModule,
    ButtonModule],
  templateUrl: './fiber-create.component.html',
  styleUrls: ['./fiber-create.component.scss'],
})
export class FiberCreateComponent {
  @Input() displayTaskModal: boolean = false;
  @Input() order: Order | null = null;
  @Output() closeTaskModal = new EventEmitter<void>();
  taskForm = new FormGroup({
    serviceName: new FormControl(''),
    clientName: new FormControl('Kathryn Murphy'),
    dueDate: new FormControl(new Date()),
    status: new FormControl('Paid'),
    items: new FormControl(2),
    total: new FormControl('$0'),
    orderId: new FormControl('#0145'),
  });
  clientPhoto = 'https://plus.unsplash.com/premium_photo-1690407617542-2f210cf20d7e?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'; // Replace with actual image URL

  statusOptions = [
    { label: 'Paid', value: 'Paid' },
    { label: 'Unpaid', value: 'Unpaid' },
  ];

  itemOptions = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
  ];

  saveChanges() {
    console.log('Saving:', this.order);
    this.closeTaskModal.emit();
  }
}

